import { Popup, Icon, Table, Button } from 'semantic-ui-react'
import './TipoEstudio.scss'
import { useAuth } from '../../../hooks';
import { getPermissions } from '../../Common/Permissions';
export  function ListadoTiposEstudio(props) {
  const {tiposEstudio, onDeleteTipoEstudio,onEditTipoEstudio,pagination,onShowTipoEstudio,countPage} = props
  
  const {auth} = useAuth()
  return (
    <Table size='small' celled  className='tabla-servicios'>
    <Table.Header className='color_header_table'>
   
      <Table.Row >
        <Table.HeaderCell>Nombre corto </Table.HeaderCell>
        <Table.HeaderCell>Nombre largo</Table.HeaderCell>
        <Table.HeaderCell>Valor ARS</Table.HeaderCell>
        <Table.HeaderCell>Acciones</Table.HeaderCell>

      </Table.Row>
    </Table.Header>

    <Table.Body style={{'borderLeft': '1px solid white'}}>
      {tiposEstudio.map((tipoEstudio,i)=>{
        
        return(<Table.Row key={i}>
         
       
         <Table.Cell > {tipoEstudio.short_name}</Table.Cell>
         <Table.Cell > {tipoEstudio.long_name}</Table.Cell>
         <Table.Cell > {tipoEstudio.value_ars}</Table.Cell>
       
         <Acciones auth={auth} tipoEstudio={tipoEstudio} onShowTipoEstudio={onShowTipoEstudio} onDeleteTipoEstudio={onDeleteTipoEstudio} onEditTipoEstudio={onEditTipoEstudio} />
       </Table.Row>
     
      )})
      } 
      
      </Table.Body> 
      <Table.Footer>
      <Table.Row>
        <Table.HeaderCell  colSpan='10'>
        {pagination}
        
        Total de registros: {countPage}
        </Table.HeaderCell>
          
        </Table.Row> 
      </Table.Footer>
  </Table>
  )
}


function Acciones(props){
  const {tipoEstudio,onDeleteTipoEstudio,onEditTipoEstudio, onShowTipoEstudio,auth} = props

 
     


  return(
    <Table.Cell  className='acciones'>
      {getPermissions("view_tipoestudio",auth) &&
    <Popup content='Ver tipo estudio' trigger={<Button size='mini' icon color="blue" basic onClick={()=>onShowTipoEstudio(tipoEstudio)}>
    <Icon name='eye' />
  </Button>} />}
        
     
      {getPermissions("change_tipoestudio",auth) &&
      <Popup content='Editar tipo estudio' trigger={<Button size='mini' icon basic onClick={()=>onEditTipoEstudio(tipoEstudio)}>
      <Icon name='pencil' />
    </Button>} />}
      {getPermissions("delete_tipoestudio",auth) &&
      <Popup content='Eliminar tipo estudio' trigger={<Button size='mini' icon negative basic onClick={()=>onDeleteTipoEstudio(tipoEstudio)}>
      <Icon name='close' />
    </Button>} />}
    </Table.Cell>
  )
}